/* 708 Supply Co. — sold-out waitlist + live stock line
   Two independent features, both product-page only:

   1. Waitlist. Watches the add-to-cart button. When the picked variant is sold
      out it hides the dead buy row and the mobile sticky bar and shows the form
      from snippets/708-notify.liquid. Submitting posts the email to Klaviyo's
      public client endpoint, tagged with the product and color the shopper
      wanted. No keys live here — they come from the 708 Product section's
      Add to cart block.

   2. Stock line. Reads the real per-variant counts the section prints into
      [data-c708-stock-map] and shows "Only N left" when the picked variant is at
      or under the threshold on that same block. qty is null on untracked
      variants, so it can never invent a number. */
(function () {
  'use strict';

  var form708 = document.getElementById('s708-form');
  var idInput = form708 ? form708.querySelector('input[name="id"]') : null;
  var atc = document.querySelector('[data-c708-atc]');

  /* Reads the option pills the shopper has picked, e.g. "Smoked/LED". */
  function variantLabel() {
    var parts = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-c708-opt-current]'), function (el) {
      var t = (el.textContent || '').trim();
      if (t) parts.push(t);
    });
    return parts.join(' / ');
  }

  /* 708-theme.js rewrites the hidden id input on every variant change, so a
     click on the option pills plus a tick is enough to read the new state. */
  function onVariantChange(fn) {
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-c708-opt]')) {
        setTimeout(fn, 0);
      }
    });
  }

  /* ---------- 1. Waitlist ---------- */
  (function waitlist() {
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var REVISION = '2024-10-15';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    var box = document.querySelector('[data-c708-notify]');
    if (!box) return;

    var form = box.querySelector('[data-c708-notify-form]');
    var input = box.querySelector('input[type="email"]');
    var button = box.querySelector('[data-c708-notify-btn]');
    var msgEl = box.querySelector('[data-c708-notify-msg]');
    var buyRow = document.querySelector('.s708-buy__row');
    var done = false;

    function message(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.className = 's708-notify__msg' + (kind ? ' is-' + kind : '');
    }

    /* The disabled attribute on add-to-cart is the single source of truth. */
    function sync() {
      var soldOut = !!(atc && atc.hasAttribute('disabled'));
      box.hidden = !soldOut;
      if (buyRow) buyRow.hidden = soldOut;
      document.body.classList.toggle('s708-soldout', soldOut);
      if (soldOut && !done) message('');
    }

    function subscribe(email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Restock product': box.getAttribute('data-product') || '',
                    'Restock handle': box.getAttribute('data-handle') || '',
                    'Restock variant': variantLabel()
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: box.getAttribute('data-list') } }
          }
        }
      };
      return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(box.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (done) return;

        var email = (input && input.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          message('Enter a valid email address.', 'err');
          if (input) input.focus();
          return;
        }

        button.classList.add('is-loading');
        button.disabled = true;
        message('');

        subscribe(email).then(function (res) {
          /* Klaviyo answers 202 with an empty body on success. */
          if (res.status >= 200 && res.status < 300) {
            done = true;
            form.hidden = true;
            message("You're on the list. We'll email you when it's back.", 'ok');
          } else {
            throw new Error('status ' + res.status);
          }
        }).catch(function () {
          message("That didn't go through. Try again, or email 708supplyco@gmail.com.", 'err');
        }).then(function () {
          button.classList.remove('is-loading');
          button.disabled = false;
        });
      });
    }

    sync();
    if (atc && window.MutationObserver) {
      new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    }
  })();

  /* ---------- 2. Live stock line ---------- */
  (function stockLine() {
    var el = document.querySelector('[data-c708-stock]');
    var data = document.querySelector('[data-c708-stock-map]');
    if (!el || !data || !idInput) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent).variants;
    } catch (err) {
      return;
    }
    if (!variants || !variants.length) return;

    var low = parseInt(el.getAttribute('data-low'), 10);
    if (!(low > 0)) low = 5;

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function render() {
      var v = find(idInput.value);
      /* qty is null unless Shopify is tracking this variant — never guess. */
      if (!v || !v.avail) {
        el.hidden = true;
        return;
      }
      var n = v.qty;
      if (typeof n !== 'number' || n <= 0 || n > low) {
        el.hidden = true;
        return;
      }
      var label = variantLabel();
      el.textContent = n === 1
        ? (label ? 'Last one in ' + label : 'Last one left')
        : ('Only ' + n + ' left' + (label ? ' in ' + label : ''));
      el.hidden = false;
    }

    render();
    onVariantChange(render);
  })();
})();
